import { render, staticRenderFns } from "./PurchaseListNew.vue?vue&type=template&id=6a030542&scoped=true"
import script from "./PurchaseListNew.vue?vue&type=script&lang=js"
export * from "./PurchaseListNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a030542",
  null
  
)

export default component.exports